module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"View our work"},"nl":{"title":"Bekijk ons werk"}}')
  delete Component.options._Ctor
}
